import "./SaralEway.css";
import eway from "../../Images/saraleway.png";
import saral1 from "../../Images/saral1.png";
import saral2 from "../../Images/saral2.png";
import saral3 from "../../Images/saral3.png";
import truck from "../../Images/truck.png";
import otherproducts from "../../Images/otherproducts.png";

import Features from "../Features";
import { eWayBillFeatures, whyChoose } from "../../utils/saralEway";
import WeOffer from "../WeOffer";
import StatsSection from "../StatsSection";
import SaralReviews from "../SaralReviews";
import ReminderBanner from "../ReminderBanner";

const SaralEway = () => {
  return (
    <main className="saral-eway-container" aria-label="Saral E-Way Bill Management Page">

      {/* SEO Hidden Images (for indexability of product images) */}
      <div className="saral-seo-hidden">
        <img src={eway} alt="Saral Eway Software" loading="lazy" />
        <img src={saral1} alt="Generate E-Way Bills Easily" loading="lazy" />
        <img src={saral2} alt="Faster E-Way Bill Processing" loading="lazy" />
        <img src={saral3} alt="E-Way Bill Automation Dashboard" loading="lazy" />
        <img src={truck} alt="Transport & Logistics Integration" loading="lazy" />
        <img src={otherproducts} alt="Other Products of Saral Suite" loading="lazy" />
      </div>

      <section className="title-section">
        <h1 className="saral-title">
          Saral E-Way <span>Bill Management</span>
        </h1>

        <p className="saral-subtitle">
          Seamless E-Way Bill Management with Saral Way
        </p>
      </section>

      <ReminderBanner />

      <StatsSection />

      <SaralReviews />

      <section aria-label="Saral E-Way Bill Features">
        <Features features={eWayBillFeatures} />
      </section>

      <section aria-label="Why Choose Saral Way">
        <WeOffer data={whyChoose} />
      </section>

    </main>
  );
};

export default SaralEway;
